import axios from "axios";
import { format, parseISO } from "date-fns";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("legalos_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
      localStorage.removeItem("legalos_token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const fmtMoney = (v) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(v || 0);
export const fmtDate = (s) => (s ? format(parseISO(s.slice(0, 10)), "d MMM yyyy") : "—");
export const fmtDateTime = (s) => (s ? format(parseISO(s), "d MMM yyyy, h:mm a") : "—");
export const todayStr = () => format(new Date(), "yyyy-MM-dd");
export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export async function openPdf(path) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank", "noopener");
}
